export default __webpack_public_path__ + "static/media/img.c59ebe81.png";